import { render, staticRenderFns } from "./Leaves.vue?vue&type=template&id=55240e07&"
import script from "./Leaves.vue?vue&type=script&lang=js&"
export * from "./Leaves.vue?vue&type=script&lang=js&"
import style0 from "./Leaves.vue?vue&type=style&index=0&id=55240e07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports